import React, { useState, useEffect } from "react";

import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { CCol, CRow } from "@coreui/react";
import { Calendar } from "primereact/calendar";
import { numFormatter } from "src/util/to-local-string/numberFormatter";
import cookie from "react-cookies"
import moment from "moment"
import { css } from "@emotion/core";
import { ScaleLoader } from "react-spinners";
import { getCurrentFinancialYear } from "src/util/miscUtil";
import { globalApiUrl } from "src/util/globalUrls";

const BalanceSheet = () => {
  const [nodes, setNodes] = useState([]);
  const [globalFilter1, setGlobalFilter1] = useState(null);
  const fisaclYear = getCurrentFinancialYear()
  useEffect(() => {
    fetchBalanceSheetData();
  }, []);

  const fetchBalanceSheetData = () => {
    setloading(true)
    settoDateToDisplay(toDate)
    fetch(
      globalApiUrl + `tallystaticreports/reports/balanceSheet?toDate=${moment(toDate, "DD/MM/YYYY").format("YYYY-MM-DD")}`, {
      headers: {
        Tenant: cookie.load("TENANT"),
      }
    }
    )
      .then((data) => data.json())
      .then((data) => {
        data.data.amount = numFormatter(data.data.amount)
        if (data.children && data.children.length > 0) {
          function loopThrough(data) {
            data.forEach(element => {
              element.data['amount'] = numFormatter(element.data?.amount)
              if (element.children && element.children.length > 0) {
                loopThrough(element.children);
              }
            })
          }
          loopThrough(data.children);
        }
        setloading(false)
        setNodes([data]);
      });
  };
  const onDataClick = (data) => {
    if (data?.data?.category && data?.data?.category == "LEDGER") {
      window.open(`/tally_search#/ledger-view?ledgerId=${data?.data?.id}`, "_blank");
    }
  }
  const actionTemplate = (data) => {
    return (
      <span className={data?.data?.category == "LEDGER" ? "c-pointer" : ""} onClick={() => onDataClick(data)}>{data?.data?.name}</span>
    )
  }
  const getHeader = (globalFilterKey) => {
    return (
      <div className="p-text-right">
        <div className="p-input-icon-right">
          <i className="pi pi-search"></i>
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter1(e.target.value)}
            placeholder="Global Search"
            size="50"
          />
        </div>
      </div>
    );
  };

  const header1 = getHeader("globalFilter1");
  const [loading, setloading] = useState(false);
  const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;
  const [toDate, setToDate] = useState(new Date(fisaclYear[1] + "-03-31") ?? null);
  const [toDateToDisplay, settoDateToDisplay] = useState("31/03/" + fisaclYear[1] ?? null);

  return (
    <div>
      <CRow className="mt-0 mb-2 input-fields">
        <CCol xl="12" lg="12" md="12" sm="12">
          <h5 className="bold-label mb-0">Balance Sheet</h5>
        </CCol>

      </CRow>
      <div className="card card-style-border-top border-0 border-left-right-bottom-0">
        <div className="card-body pt-2 pb-2 pl-0 pr-0">
          <hr className="light-border mt-0 mb-1" />
          <div className="row">
            <div className="col-xl-12 ofset-xl-1 col-lg-12 col-md-12">
              {loading && <div className="card border-0 c-app flex-row align-items-center">
                <ScaleLoader
                  css={override}
                  // size={60 , 5}
                  height={50}
                  width={5}
                  margin={5}
                  color={"#f58b3d"}
                  loading={loading}
                />
              </div>}
              {!loading && <div className="card shadow-sm card-style-border-top border-0 border-left-right-bottom-0 ribbon mt-3">
                {/* <span className="ribbon3 bg-info mdb-shadow">Balance Sheet</span> */}
                <div className="p-1">
                  <div className="card-header bg-very-light-header p-2 border-bottom-0">
                    <CRow className="input-fields">
                      <CCol xl="9" lg="8" md="6" sm="6" xs="12">
                        <CRow className="">
                          <CCol md="4 mobile-bottom">
                            <Calendar
                              id="range"
                              value={toDate}
                              className="mr-0"
                              onChange={(e) => setToDate(e.value)}
                              placeholder="As on date"
                              dateFormat="dd/mm/yy"
                            />
                          </CCol>
                          <CCol md="8 mobile-bottom">
                            <button
                              disabled={!toDate}
                              onClick={fetchBalanceSheetData}
                              label="Fetch"
                              className="btn btn-sm btn-info btn-info-line btn-shadow"
                            >
                              <i className="fas fa-arrow-down"></i> Fetch
                            </button>
                          </CCol>
                        </CRow>
                      </CCol>
                      <CCol xl="3" lg="4" md="6" sm="6" xs="12">
                        {getHeader("filter")}
                      </CCol>
                    </CRow>
                  </div>
                </div>
                <div className="card-body">
                  <div className="text-center">
                    <h5 className="mt-0 mb-2">{cookie.load("SELECTED_COMPANY")}</h5>
                    {/* <h6 className="mt-2 mb-2 bold-label text-primary">BALANCE SHEET</h6> */}
                    <p className="status-font min-font-size text-info"><i className="fas fa-calendar-alt"></i> As on {moment(toDateToDisplay, "DD/MM/YYYY").format('LL')}</p>
                  </div>
                  <div className="row">
                    <div className="col-xl-10 offset-xl-1 col-lg-12 col-md-12">
                      <div className="table-responsive balance-sheet-tree tree-no-border">
                        <TreeTable
                          value={nodes}
                          globalFilter={globalFilter1}
                        // header={header1}
                        >
                          <Column field="name" header="Name" expander body={e => actionTemplate(e)}></Column>
                          <Column field="amount" header="Amount"></Column>
                          {/* <Column field="type" header="Debit/Credit" expander></Column> */}
                        </TreeTable>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BalanceSheet;
